import substanceProportionFormSaga from './sagas';

import sagaManager from '../../../../redux/sagaManager';
import _SubstanceProportionFormContainer from './_SubstanceProportionFormContainer';

sagaManager.addSagaToRoot(substanceProportionFormSaga);

export default _SubstanceProportionFormContainer;
